import { request, LOCATION_URL, getAuthToken } from './axiosInstance';
import axios from 'axios';
// Get location pincode
export async function getLocationPincode() {
    try {
        const response = await axios.get(LOCATION_URL)
        return response.data;
    } catch (error) {
        console.log(error);
    }
}

// Add location pincode
export async function addLocationPincode(data) {
    try {
        const token = await getAuthToken();
        const response = await axios.post(LOCATION_URL, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error adding location pincode:', error.response?.data || error.message);
        throw error;
    }
}

// Get specific pincode data by pincode number
export async function getPincodeByNumber(pincode) {
    try {
        const response = await axios.get(`${LOCATION_URL}/${pincode}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching pincode data:', error);
        throw new Error('Failed to fetch pincode data');
    }
}

// Delete location pincode
export async function deleteLocationPincode(pincode) {
    try {
        const token = await getAuthToken();
        const response = await axios.delete(`${LOCATION_URL}/${pincode}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting location pincode:', error.response?.data || error.message);
        throw error;
    }
}